var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportReports01 = function SvgExportReports01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "export_reports-01_svg2__a",
    x1: -15.67,
    x2: 123.08,
    y1: 150.85,
    y2: 12.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#export_reports-01_svg2__a",
    id: "export_reports-01_svg2__b",
    x1: -7.86,
    x2: 130.89,
    y1: 158.66,
    y2: 19.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#export_reports-01_svg2__a",
    id: "export_reports-01_svg2__c",
    x1: 3.86,
    x2: 142.61,
    y1: 170.38,
    y2: 31.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#export_reports-01_svg2__a",
    id: "export_reports-01_svg2__d",
    x1: 19.48,
    x2: 158.24,
    y1: 186,
    y2: 47.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#export_reports-01_svg2__a",
    id: "export_reports-01_svg2__e",
    x1: 4.83,
    x2: 143.59,
    y1: 171.35,
    y2: 32.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.72 66.8H29.31c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h66.41c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86",
    style: {
      fill: "url(#export_reports-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31 101.95h50.78c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86H29.31c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86",
    style: {
      fill: "url(#export_reports-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31 125.39h50.78c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86H29.31c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86",
    style: {
      fill: "url(#export_reports-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.45 142.97c0 3.24 2.62 5.86 5.86 5.86h66.41c3.24 0 5.86-2.62 5.86-5.86s-2.62-5.86-5.86-5.86H29.31c-3.24 0-5.86 2.62-5.86 5.86",
    style: {
      fill: "url(#export_reports-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27 103.68h.02l-23.44-23.45a5.86 5.86 0 0 0-8.29 0 5.86 5.86 0 0 0 0 8.29L180 101.95h-27.65V44.92c0-1.55-.62-3.04-1.72-4.14L111.58 1.72A5.87 5.87 0 0 0 107.43 0H21.49C9.65 0 .01 9.64.01 21.48v157.03C.01 190.36 9.65 200 21.49 200h109.37c11.85 0 21.48-9.64 21.48-21.48v-64.84h27.65l-13.44 13.44a5.86 5.86 0 0 0 0 8.29c1.14 1.14 2.64 1.72 4.14 1.72s3-.57 4.14-1.72l23.44-23.44a5.86 5.86 0 0 0 0-8.29M113.29 20l19.06 19.06h-19.06zm27.34 81.94H100.4c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h40.23v64.86c0 5.38-4.38 9.77-9.77 9.77H21.49c-5.38 0-9.77-4.38-9.77-9.77V21.48c0-5.38 4.38-9.77 9.77-9.77h80.08v33.2c0 3.24 2.62 5.86 5.86 5.86h33.2z",
    style: {
      fill: "url(#export_reports-01_svg2__e)"
    }
  }));
};
export default SvgExportReports01;